import React, { Component } from "react";
import DateTimeRenderer from "../cell-renderer/DateTimeRenderer";
import UserDisplay from "../UserDisplay";
import { userDisplay } from "../../util/CommonFunc";
import { CFOrgStatusLabel } from "../../redux/Types";
import genre from "../../_module/definition/genre";
import i18next from "i18next";
import { __trackStatus } from "../../_clearance/definition/status";
import store from "redux/Store";
import GroupDisplay from "util/GroupDisplay";
class FormHistory extends Component {
    constructor(props) {
      super();
      this.state = {
      };
    }

    getHistView(d){
        const { 
          classes, 
          getStatus, 
          orgRuntime: {
            runtime: { _trackMusicOrigins: trackOrigins },
          },
        } = this.props;

        const { clearanceRuntime } = store.getState();
        return <>
          <>
            { d?.changedFields?.length > 0 && (
              <ul>
                {d.changedFields.filter(d=>["master", "selectedMasterForm"].indexOf(d) === -1).map(k=>{
                  switch(k){
                    case 'name':
                    case 'notes':
                    case 'synopsis':
                    case 'deadline':
                      return <li>{i18next.t(`history.fields.${k}`)} : { d.currentForm[k] }</li>
                    case 'allocatedUser':
                      return <li>{i18next.t(`history.fields.${k}`)} : { userDisplay(d.currentForm[k]) }</li>
                    case 'genre':
                      return <li>{i18next.t(`history.fields.${k}`)} : { Object.keys(genre).map(key=>genre[key]).filter(g=>g.id == d.currentForm[k])[0]?.label }</li>
                    case 'userGroup':
                    case 'productionCompany':
                      return <li>{i18next.t(`history.fields.${k}`)} : <GroupDisplay groupId={[d.currentForm[k]]} /></li>
                    case 'status':
                      break;
                      // return d.currentForm[k]?<li>{i18next.t(`history.fields.${k}`)} : <span className={classes.cfStatus} > <span style={{
                      //   backgroundColor: CFOrgStatusLabel[d.currentForm[k]].color,
                      //   width: "17px",
                      //   height: "17px",
                      //   borderRadius: "50%",                             
                      //   display: "inline-block",
                      //   verticalAlign: "middle",
                      //   marginRight: "5px",
                      // }}></span> {CFOrgStatusLabel[d.currentForm[k]].label } </span></li> : " ";
                      case "delivery":
                        return <li>{i18next.t(`history.fields.${k}`)} : {`${d.currentForm["currentEpisodeCount"] || "1"} x ${d.currentForm[k]/60}`}</li>
                      case 'clearanceFormType':
                        return <li>{i18next.t(`history.fields.${k}`)} : { clearanceRuntime?.runtime?._config?.CLEARANCE_FORM_TYPE_LIST?.find(c => +c.value === +d.currentForm[k])?.label }</li>
                      case 'newsProgrammeType':
                      case 'programmingHeaderQ15':
                      case 'producerType':
                        return <li>{i18next.t(`history.fields.${k}`)} : { clearanceRuntime?.runtime?._config?.CF_HEADER_FIELD_LIST?.find(d=>d.id === k).options.find(c => c.value === d.currentForm[k])?.label }</li>
                       
                      case 'sportsHeaderQ1':
                        let combinedValue = "";
                        const sportsHeaderQ1 = clearanceRuntime?.runtime?._config?.CF_HEADER_FIELD_LIST?.find(d=>d.id === "sportsHeaderQ1");

                        if (d.currentForm["sportsHeaderQ1"]) {
                          if (d.currentForm["sportsHeaderQ1"] && sportsHeaderQ1.subFields?.length > 0) {
                            sportsHeaderQ1.subFields.forEach((subField, index) => {
                              combinedValue += `${d.currentForm["sportsHeaderQ1"][subField.key]}${index < sportsHeaderQ1.subFields.length - 1 ? " - " : ""}`;
                            });
                          }
                        }

                        return <li>{i18next.t(`history.fields.${k}`)} : { combinedValue }</li>
  
                    default:
                      return <li>{i18next.t(`history.fields.${k}`)} : { typeof(d.currentForm[k]) !== 'object'?d.currentForm[k]:JSON.stringify(d.currentForm[k]) }</li>
    
                  }
                })}
              </ul>
            ) }
          </>
          <>
            { d?.changedTrackFields?.length > 0 ? (
              <>
              <div  className={classes.trackHistoryWrap}>
              <span className={classes.trackData}>Track Data</span>
              <ul>
                { d.currentTracks.map(t=>{
                  return d.changedTrackFields.map(k=>{
                    switch(k){
                      case "trackTitle":
                      case "catNo":
                      case "isrc":
                      case "org_sky_Source":
                      case "recordLabel":
                      case "composer":
                      case "performer":
                      case "prs":
                      case "publisher":
                        return <li>{i18next.t(`history.fields.${k}`)} to {t?.trackDetails?(t?.trackDetails[k] && Array.isArray(t?.trackDetails[k])?t?.trackDetails[k].join(", "):t?.trackDetails[k]):"-"}</li>;
                      case "musicOrigin":
                        return <li>{i18next.t(`history.fields.${k}`)} to {trackOrigins[t?.trackDetails[k]]?.label}</li>;
                      case 'clearancestatus':
                        return <li>{t?.trackDetails?.trackTitle} - {i18next.t(`history.fields.${k}`)} to
                         {t.clearancestatus && t.clearancestatus != __trackStatus.clearMe.id ? (
                          <span
                            class="clearanceValueLabel"
                            style={{
                              color: getStatus(t[k]).color,
                            }}
                          >
                            <div
                              style={{
                                background: getStatus(t[k]).color,
                              }}
                            ></div>
                            {getStatus(t[k]).name}
                          </span>
                         ): (
                          <span> Clear Me</span>
                         )}
                        { t.adminOverridden?"(Overridden)":" " } { t.adminOverriddenWithNotes }</li>
                      default:
                        if(t[k] && t[k].length>0){
                          return t[k]?<li>{t?.trackDetails?.trackTitle} - {i18next.t(`history.fields.${k}`)} to { Array.isArray(t[k])?(()=>" \r\n"+t[k].join(", "))():t[k] } { t.adminOverridden?"(Overridden)":" " } {t.adminOverriddenWithNotes}</li>:" ";
                        }
                        else{
                          return "";
                        }
                    }
                  })
                }) }
              </ul>
              </div>
              </>
            ) : d?.currentTracks?.length>0 && (
              <ul>
                { d.currentTracks.map(t=>{
                  return <li>{t?.trackDetails?.trackTitle ? (t?.trackDetails?.trackTitle) : (t?.trackDetails?.trackDetails?.trackTitle ? t?.trackDetails?.trackDetails?.trackTitle : t?.trackTitle)}</li>
                }) }
              </ul>
            
    
            
            ) }
          </>
        </>
      }
  
    render() {
      const { classes, data, migrated } = this.props;
  
      return (
        <>
            { !migrated &&
                data.map(d=>{
                  if(d?.skyMigrated){
                    return <>
                      <div className={classes.historyItem}>
                        <p className={classes.userName}>{`${d.firstName} ${d.lastName}`}</p>
                        <p className={classes.changedDate}> <DateTimeRenderer data={d.dateCreated} /> </p>
                        <p className={classes.actionName}>{d.eventTypeDesc}</p>
                        { d.trackTitle && (
                          <p className={classes.userName}>{d.trackTitle}</p>
                        ) }
                        {d.action && 
                          <div  className={classes.trackHistoryWrap}>
                            <span className={classes.trackData}>Track Data</span>
                            <ul>
                              { d.action.split(";;").map(d=>{
                                return <li>{d}</li>
                              }) }
                            </ul>
                          </div>
                        }
                      </div>
                    </>
                  }
                  else{
                    return <>
                      <div className={classes.historyItem}>
                      <p className={classes.userName}>
                          <UserDisplay userId={d.by} />
                        </p>
                        <p className={classes.changedDate}>
                          <DateTimeRenderer data={d.at} />
                        </p>
                        <p className={classes.actionName}>{d.actionType == "edittracks"?`Track ${i18next.t(`history.keys.${d.actionType}`)}`:i18next.t(`history.keys.${d.actionType}`)}</p>
                        <div className={classes.objectName}>
                          {this.getHistView(d)}
                        </div>
                      
                      </div>
                    </>
                  }
                })
            }
            {
              migrated &&  data.map(d=>{
                return <>
                <div className={classes.historyItem}>
                  <p className={classes.userName}>{`${d.firstName} ${d.lastName}`}</p>
                  <p className={classes.changedDate}> <DateTimeRenderer data={d.dateCreated} /> </p>
                  <p className={classes.actionName}>{d.eventTypeDesc}</p>
                  { d.trackTitle && (
                    <p className={classes.userName}>{d.trackTitle}</p>
                  ) }
                  {d.action && 
                    <div  className={classes.trackHistoryWrap}>
                      <span className={classes.trackData}>Track Data</span>
                      <ul>
                        { d.action.split(";;").map(d=>{
                          return <li>{d}</li>
                        }) }
                      </ul>
                    </div>
                  }
                </div>
                </>})
            }
        </>
      );
    }
  }
  
export default FormHistory;